module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/transporter.svg?ab51cade02c303e80ac180c01750f6c0";